/**
 * Quick Deposit Service
 */

define(function(require, exports, module) {
    'use strict';

    var core = require('core');
    var user = require('user');
    var QuickDepositMethodCollection = require('modules/cashier/quick-deposit/quick-deposit.collection');
    var BaseModel = require('common/base.model');
    const { dispatcher } = require('bundle');

    module.exports = BaseModel.extend({

        defaults: {
            isQuickDepositAvailable: false
        },

        initialize: function() {
            this.methods = new QuickDepositMethodCollection();
            this._fetchQuickDepositCollection();
        },

        subscribe: function() {
            this.listenTo(core, {
                'auth:login auth:logout deposit:success': this._fetchQuickDepositCollection
            });
        },

        isQuickDepositAvailable: function() {
            return this.get('isQuickDepositAvailable');
        },

        _fetchQuickDepositCollection: function() {
            if (!user.isLoggedIn()) {
                this._setQuickDepositAvailability(false);
                return;
            }

            this.methods.fetch().done(this._setQuickDepositAvailability.bind(this));
        },

        _setQuickDepositAvailability: function(value) {
            var isAvailable = typeof value === 'boolean'
                ? value
                : Boolean(this.methods.getMethod() && this.methods.getMethod().get('quickDeposit'));
            this.set('isQuickDepositAvailable', isAvailable);

            if (dispatcher) {
                dispatcher.dispatch('quickDeposit:setIsAvailable', { isQuickDepositAvailable: isAvailable });
            }
        }

    });
});
